import React from "react";
import DefaultTable from "../../components/Common/DefaultTable";
import { useHistory } from "react-router";
import { formatDatesOnList } from "helpers/utils";
import { Box, Chip, TableRow } from "@material-ui/core";
import ExpandableChips from "components/Common/ExpandableChips";

function ActorsTable(props) {
  const {
    actors,
    headCells,
    isLoading,
    defaultTable,
    handleEntityClick,
    optionalCellRender,
  } = props;
  const history = useHistory();

  const {
    renderHeadCell,
    renderCheckAllCell,
    renderBodyCell,
    isSelected,
    renderCheckRowCell,
    handleClick,
  } = defaultTable;

  const formattedActors = formatDatesOnList(
    actors,
    "LLL",
    "firstActivityDate",
    "lastActivityDate",
    "lastUpdatedAt"
  );

  const renderDefaultBody = () => {
    return formattedActors.map((actor) => {
      const { actorId: id } = actor;
      const isItemSelected = isSelected(id);

      return (
        <TableRow
          hover
          role="checkbox"
          onClick={() => {
            handleEntityClick(actor);
          }}
          aria-checked={isItemSelected}
          tabIndex={-1}
          key={id}
          selected={isItemSelected}
        >
          {renderCheckRowCell(isItemSelected, id, (e) => {
            handleClick(e, id);
          })}
          {optionalCellRender("actorId", renderBodyCell(id))}
          {optionalCellRender("name", renderBodyCell(actor.name))}
          {optionalCellRender(
            "firstActivityDate",
            renderBodyCell(actor.firstActivityDate, { width: 100 })
          )}
          {optionalCellRender(
            "lastActivityDate",
            renderBodyCell(actor.lastActivityDate, { width: 100 })
          )}
          {optionalCellRender(
            "actorType",
            renderBodyCell(actor.actorType, { width: 80 })
          )}
          {optionalCellRender(
            "knownAs",
            renderBodyCell(actor.knownAs, { width: 100 })
          )}
          {optionalCellRender(
            "capability",
            renderBodyCell(actor.capability, { width: 80 })
          )}
          {optionalCellRender(
            "motivations",
            renderBodyCell(
              <Box
                style={{
                  display: "flex",
                  minWidth: "70px",
                  flexWrap: "wrap",
                  maxWidth: "222px",
                  width: `${actor?.motivations?.length * 36}px`,
                  my: 1,
                  gap: 1,
                }}
              >
                <ExpandableChips
                  dataArray={actor.motivations ?? []}
                  style={{
                    maxWidth: 100,
                    minWidth: 150,
                    fontWeight: 500,
                  }}
                  ellipsisProps={{
                    maxWidth: "80px",
                  }}
                />
              </Box>
            )
          )}
          {optionalCellRender(
            "cves",
            renderBodyCell(
              <Box
                style={{
                  display: "flex",
                  minWidth: "200px",
                  flexWrap: "wrap",
                  maxWidth: "222px",
                  width: `${actor?.cves?.length * 36}px`,
                  my: 1,
                  gap: 1,
                }}
              >
                <ExpandableChips
                  dataArray={actor.cves ?? []}
                  style={{
                    maxWidth: 100,
                    minWidth: 150,
                    fontWeight: 500,
                  }}
                  ellipsisProps={{
                    maxWidth: "150px",
                  }}
                />
              </Box>
            )
          )}
          {optionalCellRender(
            "origins",
            renderBodyCell(
              <Box
                style={{
                  display: "flex",
                  minWidth: "200px",
                  flexWrap: "wrap",
                  maxWidth: "222px",
                  width: `${actor?.origins?.length * 36}px`,
                  my: 1,
                  gap: 1,
                }}
              >
                <ExpandableChips
                  dataArray={actor.origins ?? []}
                  style={{
                    maxWidth: 100,
                    minWidth: 150,
                    fontWeight: 500,
                  }}
                  ellipsisProps={{
                    maxWidth: "80px",
                  }}
                />
              </Box>
            )
          )}
          {optionalCellRender(
            "targetedLocations",
            renderBodyCell(
              <Box
                style={{
                  display: "flex",
                  minWidth: "200px",
                  flexWrap: "wrap",
                  maxWidth: "222px",
                  width: `${actor?.targetedLocations?.length * 36}px`,
                  my: 1,
                  gap: 1,
                }}
              >
                <ExpandableChips
                  dataArray={actor.targetedLocations ?? []}
                  style={{
                    maxWidth: 100,
                    minWidth: 150,
                    fontWeight: 500,
                  }}
                  ellipsisProps={{
                    maxWidth: "80px",
                  }}
                />
              </Box>
            )
          )}
          {optionalCellRender(
            "targetIndustries",
            renderBodyCell(
              <Box
                style={{
                  display: "flex",
                  minWidth: "200px",
                  flexWrap: "wrap",
                  maxWidth: "222px",
                  width: `${actor?.targetIndustries?.length * 36}px`,
                  my: 1,
                  gap: 1,
                }}
              >
                <ExpandableChips
                  dataArray={actor.targetIndustries ?? []}
                  style={{
                    maxWidth: 100,
                    minWidth: 150,
                    fontWeight: 500,
                  }}
                  ellipsisProps={{
                    maxWidth: "80px",
                  }}
                />
              </Box>
            )
          )}
          {optionalCellRender(
            "lastUpdatedAt",
            renderBodyCell(actor.lastUpdatedAt, { width: 100 })
          )}
        </TableRow>
      );
    });
  };

  return (
    <>
      <DefaultTable
        headCells={headCells}
        renderCheckAllCell={renderCheckAllCell}
        renderDefaultBody={renderDefaultBody}
        renderHeadCell={renderHeadCell}
        rows={formattedActors}
        onRowClick={(row) => {
          history.push(`/actors/${row.actorId}`);
        }}
        isLoading={isLoading}
        selectableRows
      />
    </>
  );
}

export default ActorsTable;
